import React, { createContext, useState, useMemo, useEffect, useContext } from "react";
import CommonServices from "../services/commonServices";
import msalInstance from "../configs/auth/msalInstance";
import { useLoader } from "./loaderContext";
import { roleCode } from "../utils/constants";
import SuppliersServices from "../services/suppliersServices";

export const CurrentUserContext = createContext();

export const CurrentUserProvider = ({ children }) => {

    const { setLoading} = useLoader();
    const [currentUser, setCurrentUser] = useState(null);
    const [error, setError] = useState(null);


    useEffect(() => {
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount) {
            retrieveCurrentUserData(activeAccount.localAccountId);
        }
    }, []);

    // const retrieveCurrentUserData = async (currentUserId) => {
    //     setLoading(true);
    //     try {
    //         const respData = await CommonServices.getCurrentUser(currentUserId);
    //         if (respData.success) {
    //             const userData = respData.responseObject.value.userDto;

    //             if (userData.roleCode === roleCode.archivio) {
    //                 let filters = { name: "", vatCode: "", enabled: true, userID: userData.id, availableSuppliers: false, categoryID: userData.lastSelectedCategory };
    //                 const suppliersRes = await SuppliersServices.getSuppliers(filters);
    //                  const supplierList = suppliersRes.responseObject.value.supplierListDTO; 
    //                  if(supplierList && supplierList.length === 1){
    //                     userData.supplierID = supplierList[0].id;
    //                  }     
    //             }

    //             console.log("userData on context", userData)
    //             setCurrentUser(userData);
    //         }
    //         setLoading(false);
    //     } catch (error) {
    //         setError(error.message);
    //         setLoading(false);
    //         console.error('Failed to fetch:', error.message);
    //     }
    // };

    const retrieveCurrentUserData = async (currentUserId) => {
        setLoading(true);

        try {
            const respData = await CommonServices.getCurrentUser(currentUserId);

            if (respData.success) {
                const userData = respData.responseObject.value.userDto;

                // --- Move logic outside main try/catch, but protect the risky part ---
                if (userData.roleCode === roleCode.archivio) {

                    try {
                        let filters = {
                            name: "",
                            vatCode: "",
                            enabled: true,
                            userID: userData.id,
                            availableSuppliers: false,
                            // categoryID: userData.lastSelectedCategory
                        };

                        const suppliersRes = await SuppliersServices.getSuppliers(filters);
                        const supplierList = suppliersRes.responseObject.value.supplierListDTO;

                        if (supplierList && supplierList.length === 1) {
                            userData.supplierID = supplierList[0].id;
                        }
                    } catch (e) {
                        console.warn("Failed to load suppliers for archivio role:", e.message);
                        // Continue without blocking the main flow
                    }
                }

                console.log("userData on context", userData);
                setCurrentUser(userData);
            }

            setLoading(false);

        } catch (error) {
            setError(error.message);
            setLoading(false);
            console.error("Failed to fetch:", error.message);
        }
    };

    // const currentUserValue = useMemo(() => ({ currentUser, error }), [currentUser, error]);

    return (
        <CurrentUserContext.Provider value={{ currentUser, error }}>
            {children}
        </CurrentUserContext.Provider>
    )
}

export const useCurrentUserContext = () => useContext(CurrentUserContext);